module.exports = __webpack_public_path__ + "img/11.72f162e7.png";